//@flow
import * as React from 'react';
import { themr } from 'react-css-themr';
import theme from './Chip.scss';
import classnames from 'classnames';
import StringUtils from 'common/utils/StringUtils';
import { TooltipDivOverflow } from 'common/components/core/wrappers/Div';
import Icon from 'common/components/core/icon';

type Props = {
    invert: boolean,
    label: string,
    text: string,
    leftIcon?: string,
    leftBorderColor?: string,
    className: string,
    theme: Object,
    emptyText: string,
    backgroundColor?: string,
    showEmptyText: boolean,
    showOverflowTooltip: boolean,
    noPadding?: boolean,
    rightIcon?: Object,
    rightIconProps?: Object,
    style: Object,
    onContextMenu: () => void,
    onClick: () => void,
    testId?: string,
    disabled?: boolean
};

class Chip extends React.PureComponent<Props, void> {
    render() {
        const {
            label,
            theme,
            text,
            leftBorderColor,
            leftIcon,
            className,
            invert,
            emptyText,
            showEmptyText,
            showOverflowTooltip,
            style,
            onContextMenu,
            onClick,
            backgroundColor,
            rightIcon,
            rightIconProps,
            noPadding,
            testId,
            disabled
        } = this.props;
        let displayText = text;
        let isEmpty = false;
        if (emptyText && StringUtils.isEmpty(text) && showEmptyText) {
            isEmpty = true;
            displayText = emptyText;
        }
        const backgroundColorClass =
            backgroundColor && theme[`${backgroundColor}Bg`];
        return displayText ? (
            <div
                testId={testId}
                onContextMenu={onContextMenu}
                onClick={onClick}
                style={style}
                className={classnames(theme.chipWrap, className, {
                    [theme.invert]: invert,
                    [theme.hasRightIcon]: rightIcon && theme.hasRightIcon,
                    [theme.noPadding]: noPadding && theme.noPadding,
                    [theme.disabled]: disabled && theme.disabled,
                    [backgroundColorClass]: !!backgroundColorClass
                })}
            >
                <div
                    className={theme.chip}
                    style={{ borderColor: leftBorderColor }}
                >
                    {leftIcon ? (
                        <Icon
                            className={theme.leftIcon}
                            theme={theme}
                            icon={leftIcon}
                            invert={invert}
                        />
                    ) : null}
                    {label && !isEmpty ? (
                        <span className={theme.label}>{label}</span>
                    ) : null}
                    <TooltipDivOverflow
                        invert
                        small
                        tooltip={
                            showOverflowTooltip
                                ? label
                                    ? `${label} ${displayText}`
                                    : displayText
                                : ''
                        }
                        className={theme.text}
                    >
                        {displayText}
                    </TooltipDivOverflow>

                    {rightIcon ? (
                        <Icon
                            className={theme.rightIcon}
                            theme={theme}
                            icon={rightIcon}
                            invert={invert}
                            disabled={disabled}
                            {...rightIconProps}
                        />
                    ) : null}
                </div>
            </div>
        ) : null;
    }
}
const ThemedChip = themr('Chip', theme)(Chip);

export { Chip as UnthemedChip, ThemedChip as Chip };
export default ThemedChip;
